import { render, staticRenderFns } from "./AdServingRecommendation.vue?vue&type=template&id=d8907de8&"
import script from "./AdServingRecommendation.vue?vue&type=script&lang=js&"
export * from "./AdServingRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports